import axios from "./axios";
import useAuth from "../context/useAuth";
import useApi from '../api/useApi';

const useLogout = () => {
    const { setAuth } = useAuth();
    const api = useApi();

    const logout = async () => {
        setAuth({});
        try {
            await api.logout();
        } catch (e) {
            console.log(e);
        }
    }
    return logout;


}

export default useLogout;